import Component from '@bythepixel/component-loader';
import MicroModal from 'micromodal';

const openClass = 'modal--open';
const successClass = 'modal--success';

export default class Modal extends Component {
  static selector = '[data-comp-modal-trigger]'

  constructor(...args) {
    super(...args);
    this.modalId = `${this.$container.dataset.compModalTrigger}-modal`;
    this.modalContainer = document.getElementById(this.modalId);

    if (!this.modalContainer) {
      console.warn(`[MicroModalAdaptor] Modal with id '${this.modalId} is not found.`);
      return;
    }

    this.modalController = MicroModal;
    this.modalCloseTriggers = this.modalContainer.querySelectorAll('[data-comp-modal-close-trigger]');

    this.initCloseEvents = this.initCloseEvents.bind(this);
    this.boundApplyHiddenStyles = () => this.applyHiddenStyles();
    this.events();
  }

  show() {
    this.modalController.show(this.modalId, {
      awaitCloseAnimation: true,
      disableScroll: true,
      onClose: this.initCloseEvents,
      openClass,
    });
  }

  close() {
    this.modalController.close(this.modalId);
  }

  applyHiddenStyles() {
    this.modalContainer.removeEventListener('animationend', this.boundApplyHiddenStyles);
    this.modalContainer.classList.remove(openClass);
  }

  events() {
    this.$container.addEventListener('click', () => this.show());
    this.modalCloseTriggers.forEach(el => el.addEventListener('click', () => this.close()));
  }

  initCloseEvents() {
    this.modalContainer.addEventListener('animationend', this.boundApplyHiddenStyles);

    // Only contact form modals have a success class
    if (this.modalContainer.classList.contains(successClass)) {
      // Wait a bit before removing this class to account for the fade-out transition
      setTimeout(() => {
        this.modalContainer.classList.remove(successClass);
      }, 400);
    }
  }
}
